export class ResidentModel {
    id: string;
    institutionId: string;
    firstName: string;
    lastName: string;
    labelName: string;
    sortName: string;
    residencyBeginDate: Date;
    residencyEndDate: Date;
    residencyPostGraduateYear: string;
    institutionalEmailAddress: string;
    nonInstitutionalEmailAddress: string;
    canEditTransition: boolean;
    isTransitioned: boolean;
    credentialCode: string;
    canEditCredentialCode: boolean;
    npi: string;
}
